import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Plan {
  id: number;
  name: string;
  price: number;
  status: 'active' | 'inactive';
  createdAt?: Date;
  updatedAt?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class PlansService {
  private apiUrl = `${environment.api}/plans`;

  constructor(private http: HttpClient) {}

  getPlans(page: number = 1, search: string = ''): Observable<any> {
    const params = { page: page.toString(), search };
    return this.http.get(this.apiUrl, { params });
  }

  createPlan(name: string): Observable<any> {
    return this.http.post(this.apiUrl, { name });
  }

  updatePlan(id: number, name: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, { name });
  }

  inactivatePlan(id: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${id}/inactivate`, {});
  }

  getPlan(planId: number): Observable<Plan> {
    return this.http.get<Plan>(`${this.apiUrl}/${planId}`);
  }
}
